<section class="container__main">

    <section class="container__content">
        <section class="container__content_main">
            <app-contents 
                nomeBlog="Meu Blog" 
                msgWelcome="Sejam Bem-vindos ao blog de" 
                autorName="Edimilson Borges"
                btnText="Novidades"
                linkDetails="Explore"
                msgDetails="uma variedade de tópicos que vão desde dicas de viagem e reflexões sobre a vida até insights sobre tecnologia e cultura. Este é um espaço onde podemos nos conectar, aprender e crescer juntos. Então, pegue uma xícara de café, acomode-se confortavelmente e venha explorar as páginas deste blog feito para todos os públicos.">
            </app-contents>

            <section class="small-card">
                <app-small-card titleSmallCard="There are many variations of passages" descriptionSmallCard=" All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable"></app-small-card>
                <app-small-card titleSmallCard="ontrary to popular belief, Lorem Ipsum" descriptionSmallCard="Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum "></app-small-card>
            </section>
        </section>
        <section class="container__content_rigth">
            <app-card-rigth *ngFor="let post of posts" id={{post.id}} dateCardRigth={{post.date}} imgCardRigth={{post.photo}} decriptionCardRigth={{post.title}} ></app-card-rigth>
        </section>
    </section>
</section>